import { render, staticRenderFns } from "./GeneralRevenue.vue?vue&type=template&id=1677a3fe&scoped=true"
import script from "./GeneralRevenue.vue?vue&type=script&lang=js"
export * from "./GeneralRevenue.vue?vue&type=script&lang=js"
import style0 from "./GeneralRevenue.vue?vue&type=style&index=0&id=1677a3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1677a3fe",
  null
  
)

export default component.exports